import { render } from "./ChatInterface.vue?vue&type=template&id=3893156e"
import script from "./ChatInterface.vue?vue&type=script&lang=js"
export * from "./ChatInterface.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__